var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy } from '@angular/core';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { Subject, Observable } from 'rxjs';
import { Select, Store, Actions, ofActionCompleted } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { takeUntil, filter } from 'rxjs/operators';
import { SetSelectedChapterBackground, SetAllChaptersBackground, ResetSelectedChapterBackground } from 'src/app/story/state/chapters/story.chapters.actions';
import { FormBuilder, Validators } from '@angular/forms';
import { TabComponent } from 'src/app/shared/components/tabs/tab/tab.component';
import { environment } from 'src/environments/environment';
import { plainToClass } from 'class-transformer';
import { MatSnackBar } from '@angular/material/snack-bar';
import { loftSwatch, studioSwatch, transparentBackground } from './background-config';
import { isEqual } from 'lodash';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';
var BackgroundColorDialogComponent = /** @class */ (function () {
    function BackgroundColorDialogComponent(store, actions, fb, snackBar) {
        this.store = store;
        this.actions = actions;
        this.fb = fb;
        this.snackBar = snackBar;
        // environment based preset swatch
        this.presetBackgrounds = environment.exportType === 'module'
            ? plainToClass(BackgroundModel, loftSwatch) // loft
            : plainToClass(BackgroundModel, studioSwatch); // studio
        this.ngUnsubscribe = new Subject();
    }
    BackgroundColorDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initPresets();
        this.initForm();
        // messaging
        this.actions.pipe(ofActionCompleted(SetAllChaptersBackground), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackBar.open('Successfully applied color to all chapters.');
        });
    };
    BackgroundColorDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    BackgroundColorDialogComponent.prototype.initPresets = function () {
        var _this = this;
        // track selected preset
        this.presetBackground = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
        this.background$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (background) {
            _this.presetBackground = background;
        });
        // track distinct chapter backgrounds
        this.allChapterBackgrounds$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (backgrounds) {
            _this.distinctBackgrounds = backgrounds.filter(function (background, index) {
                return backgrounds.findIndex(function (searchBackgound) { return _this.backgroundsEqual(background, searchBackgound); }) === index;
            });
        });
    };
    BackgroundColorDialogComponent.prototype.initForm = function () {
        var _this = this;
        // get current chapter defaults
        var chapterBackground = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
        // setup form
        this.form = this.fb.group({
            type: ['solid', [Validators.required]],
            color1: ['', [Validators.required]],
            stop1: [0, [Validators.required, Validators.min(0), Validators.max(100)]],
            color2: ['', [Validators.required]],
            stop2: [100, [Validators.required, Validators.min(0), Validators.max(100)]]
        });
        // setup events: set custom background
        this.form.valueChanges
            .pipe(filter(function () { return _this.customTab.isActive; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.applyFromCustom();
        });
        // set initial form values
        if (chapterBackground) {
            this.setCustomColorForm(chapterBackground);
        }
    };
    BackgroundColorDialogComponent.prototype.handleFormColorSelected = function (fieldName, color) {
        this.form.get(fieldName)
            .setValue(color);
    };
    BackgroundColorDialogComponent.prototype.handlePresetSelected = function (background) {
        this.presetBackground = background;
        this.store.dispatch(new SetSelectedChapterBackground(background));
    };
    BackgroundColorDialogComponent.prototype.handleResetClick = function () {
        this.store.dispatch(new ResetSelectedChapterBackground());
    };
    BackgroundColorDialogComponent.prototype.handleTabChange = function (tab) {
        // apply custom preset
        if (this.customTab.isActive && this.presetBackground) {
            this.setCustomColorForm(this.presetBackground);
        }
    };
    BackgroundColorDialogComponent.prototype.backgroundsEqual = function (backgroundA, backgroundB) {
        return isEqual(backgroundA, backgroundB);
    };
    BackgroundColorDialogComponent.prototype.getBackgroundHex = function (background) {
        var colors = background.colors;
        return ColorUtils.rgbToHex([colors[0], colors[1], colors[2]]);
    };
    BackgroundColorDialogComponent.prototype.getFormBackgroundHex = function (fieldName) {
        return this.form.get(fieldName).value;
    };
    BackgroundColorDialogComponent.prototype.applyAll = function () {
        var type = this.form.value.type;
        // determine mode
        if (this.presetTab.isActive) {
            this.store.dispatch(new SetAllChaptersBackground(this.presetBackground));
        }
        else if (this.customTab.isActive) {
            var customBackground = this.formToBackgroundColor(type);
            if (customBackground) {
                this.store.dispatch(new SetAllChaptersBackground(customBackground));
            }
        }
    };
    BackgroundColorDialogComponent.prototype.applyFromCustom = function () {
        var type = this.form.value.type;
        var customBackground = this.formToBackgroundColor(type);
        if (customBackground) {
            this.store.dispatch(new SetSelectedChapterBackground(customBackground));
        }
    };
    BackgroundColorDialogComponent.prototype.setCustomColorForm = function (background) {
        var type = 'solid';
        var color1 = '';
        var color2 = '';
        var stop1 = 0;
        var stop2 = 100;
        var colors = background.colors, gradientType = background.gradientType, colorStops = background.colorStops;
        // set colors
        var firstRGB = [
            colors[0],
            colors[1],
            colors[2]
        ];
        var secondRGB = colors.length < 8
            ? firstRGB
            : [
                colors[4],
                colors[5],
                colors[6]
            ];
        color1 = ColorUtils.rgbToHex(firstRGB, false);
        color2 = ColorUtils.rgbToHex(secondRGB, false);
        // set type: handle transparent
        if (BackgroundModel.isTransparent(background)) {
            type = 'transparent';
        }
        else if (isEqual(firstRGB, secondRGB)) {
            type = 'solid';
        }
        else {
            type = gradientType;
        }
        // set stops
        stop1 = colorStops[0];
        stop2 = colorStops[1];
        this.form.patchValue({
            type: type,
            color1: color1,
            stop1: stop1,
            color2: color2,
            stop2: stop2
        });
    };
    BackgroundColorDialogComponent.prototype.formToBackgroundColor = function (type) {
        var _a = this.form.value, color1 = _a.color1, color2 = _a.color2, stop1 = _a.stop1, stop2 = _a.stop2;
        var formGroup = this.form;
        // special case
        if (type === 'transparent') {
            return transparentBackground;
        }
        // validation
        if (!formGroup.valid) {
            return null;
        }
        var background;
        var colors = [];
        var gradientType = type === 'radial' ? 'radial' : 'linear';
        // set color 1
        if (color1) {
            colors.push.apply(colors, __spread(ColorUtils.hexToRgb(color1, false), [1]));
        }
        // set color 2
        if (color2 && type !== 'solid') {
            colors.push.apply(colors, __spread(ColorUtils.hexToRgb(color2, false), [1]));
        }
        else { // repeat color
            colors.push.apply(// repeat color
            colors, __spread(colors));
        }
        background = new BackgroundModel(colors, gradientType, [stop1, stop2]);
        return background;
    };
    __decorate([
        Select(StoryChaptersState.getSelectedChapterBackground),
        __metadata("design:type", Observable)
    ], BackgroundColorDialogComponent.prototype, "background$", void 0);
    __decorate([
        Select(StoryChaptersState.getAllChaptersBackground),
        __metadata("design:type", Observable)
    ], BackgroundColorDialogComponent.prototype, "allChapterBackgrounds$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], BackgroundColorDialogComponent.prototype, "selectedChapterIndex$", void 0);
    return BackgroundColorDialogComponent;
}());
export { BackgroundColorDialogComponent };
